import style from './VerticalContainer.module.css';

interface Props {
  children: React.ReactNode;
}

export default function VerticalContainer({ children }: Props) {
  return <div className={style.verticalContainer}>{children}</div>;
}
